import React, { forwardRef } from 'react';
import { ButtonBase } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
    ArrowRight1LightLinearIcon,
    ArrowRight1LinearIcon
} from '../../icons-lib';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const CustomButtonBase = styled(ButtonBase)(({ theme, variant }) => ({
    borderRadius: '50%',
    padding: theme.spacing(1),
    borderStyle: 'solid',
    borderWidth: 1,
    ...(variant === 'light' && {
        "backgroundColor": alpha(theme.palette.background.neutral, 0.3),
        "borderColor": alpha(theme.palette.background.default, 0.3),
        "color": theme.palette.grey[50],
        '& .MuiTouchRipple-root .MuiTouchRipple-rippleVisible': {
            color: alpha(theme.palette.background.paper, 0.8)
        }
    }),
    ...(variant === 'dark' && {
        "backgroundColor": theme.palette.background.neutral,
        "borderColor": theme.palette.grey[200],
        '& .MuiTouchRipple-root .MuiTouchRipple-rippleVisible': {
            color: theme.palette.grey[400]
        }
    })
}));

const ArrowButton = forwardRef(({ variant = 'light', onClick }, ref) => {
    return (
        <CustomButtonBase ref={ref} onClick={onClick} variant={variant}>
            {variant === 'light' ? (
                <ArrowRight1LightLinearIcon />
            ) : (
                <ArrowRight1LinearIcon />
            )}
        </CustomButtonBase>
    );
});

ArrowButton.propTypes = {
    variant: PropTypes.oneOf(['light', 'dark']),
    onClick: PropTypes.func
};

export default ArrowButton;
